<template>
  <input :type="type" :value="value" @input="updateValue" @keyup.enter="enter()" @click="clicked()" :autocomplete="autocomplete" class="w-full border rounded-md p-2 appearance-none focus:outline-none bg-transparent" />
</template>

<script>
export default {
  name: 'textField',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    enter () {
      this.$emit('enter', true)
    },
    clicked () {
      this.$emit('clicked', true)
    }
  }
}
</script>

<style>

</style>
